import styled from 'styled-components';

export const LiStyled = styled.li`
	margin: 0;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		font-size: 14px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		font-size: 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		font-size: 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		font-size: 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		font-size: 16px;
	}
`;

export const ImgStyled = styled.img`
	margin-bottom: 24px;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: 328px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 508px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 462px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 621px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 621px;
	}
`;
